import React, {useState} from "react";
import {List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import styles from "./styles.module.css";
import {CheckIcon} from "../../../assets/files";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../store";
import {languageData} from "../types";
import {setUser} from "../../../store/reducer";
import {useUpdateProfileMutation} from "../../../api/modules";
import {useTranslation} from "react-i18next";


interface IProps {
    language?: string | null;
    id?: number | string | null
}

const ProfileLanguage: React.FC<IProps> = (props) => {
    const {language, id} = props;
    const {i18n} = useTranslation();
    const dispatch: AppDispatch = useDispatch();
    const [selectedIndex, setSelectedIndex] = useState<string>(language || "en");
    const [updateProfile] = useUpdateProfileMutation()

    const handleListItemClick = async (key: string) => {
        if (id) {
            setSelectedIndex(key);
            try {
                const res = await updateProfile({id, body: {language: key}}).unwrap();
                if (res) {
                    await i18n.changeLanguage(key);
                    dispatch(setUser(res));
                }
            } catch (err) {
                console.log("err", err);
            }
        }
    };

    return (
        <div className={styles.root}>
            <List className={styles.list}>
                {languageData.map(({name, key}) => (
                    <ListItemButton
                        key={key}
                        onClick={() => handleListItemClick(key)}
                        selected={selectedIndex === key}
                    >
                        <ListItemIcon>{selectedIndex === key && <CheckIcon/>}</ListItemIcon>
                        <ListItemText primary={name} className={styles.name}/>
                    </ListItemButton>
                ))}
            </List>
        </div>
    );
};

export default ProfileLanguage;
